/* eslint-disable react/require-default-props */
import { Content, Extensions } from "@tiptap/react";
import { RichTextReadOnly } from "mui-tiptap";
import React from "react";

import useExtensions from "./extensions/useExtensions";

type Props = {
  content: Content;
  extensions?: Extensions;
};

const ReadOnlyEditor: React.FC<Props> = ({ content, extensions }) => {
  const defaultExtensions = useExtensions({});
  return (
    <RichTextReadOnly
      content={content}
      extensions={extensions || defaultExtensions}
      parseOptions={{ preserveWhitespace: "full" }}
    />
  );
};

export default ReadOnlyEditor;
